import { generateClient, GraphQLResult } from "aws-amplify/api";
import { FormTemplateForResolver } from "db/definitions";
// @ts-ignore
import { listFormTemplates } from "../graphql/queries";
import { recordSentry } from "./recordSentry";

async function getFormTemplates(): Promise<FormTemplateForResolver[]> {
	const instances = await getBatch(null, []);
	return instances;
}

async function getBatch(nextToken: string | null, prevItems: FormTemplateForResolver[]): Promise<FormTemplateForResolver[]> {
	try {
		interface QueryResult {
			listFormTemplates: {
				items: FormTemplateForResolver[];
				nextToken: string | null;
			};
		}
		const client = generateClient({ authMode: "userPool" });
		const result = (await client.graphql({
			query: listFormTemplates,
			variables: {
				nextToken,
				limit: 50,
			},
			authMode: "userPool",
		})) as GraphQLResult<QueryResult>;
		const instances = result.data.listFormTemplates;
		if (instances.nextToken) {
			prevItems = prevItems.concat(instances.items);
			return getBatch(instances.nextToken, prevItems);
		} else {
			prevItems = prevItems.concat(instances.items);
			return prevItems;
		}
	} catch (error) {
		recordSentry({ error, msg: "Error getting all the Form Templates: " });
		return [];
	}
}

export default getFormTemplates;
